import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class PaymentService {
  /**
   * Submit internship request and initialize payment
   * @param {Object} requestData - Internship request form data
   */
  async submitRequest(requestData) {
    try {
      const response = await axios.post(`${API_BASE_URL}/internship/request`, requestData);
      return response.data;
    } catch (error) {
      console.error('Error submitting request:', error);
      throw error.response?.data || error;
    }
  }

  /**
   * Verify payment status
   * @param {string} reference - Payment reference to verify
   */
  async verifyPayment(reference) {
    try {
      const response = await axios.post(`${API_BASE_URL}/internship/verify-payment/${reference}`);
      return response.data;
    } catch (error) {
      console.error('Error verifying payment:', error);
      throw error.response?.data || error;
    }
  }

  /**
   * Handle payment completion
   * @param {string} reference - Payment reference from URL
   * @param {Function} onSuccess - Success callback
   * @param {Function} onError - Error callback
   */
  async handlePaymentCompletion(reference, onSuccess, onError) {
    try {
      console.log('PaymentService: Verifying payment for reference:', reference);
      const result = await this.verifyPayment(reference);
      console.log('PaymentService: Verification result:', result);
      
      if (result.success) {
        console.log('PaymentService: Calling success callback with data:', result.data);
        onSuccess(result.data);
      } else {
        console.log('PaymentService: Calling error callback with message:', result.message);
        onError(result.message);
      }
    } catch (error) {
      console.log('PaymentService: Error during verification:', error);
      onError(error.message || 'Payment verification failed');
    }
  }
}

export const paymentService = new PaymentService();
